"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagInputExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/tag-input/examples/index.ts';
var tags = ['First', 'Second', 'Third'];
var TagInputExample = /** @class */ (function () {
    function TagInputExample() {
        var _this = this;
        this.disabled = false;
        this.addOnBlur = false;
        this.tags = tslib_1.__spreadArray([], tags, true);
        this.onAdd = function (value) {
            _this.tags.push(value);
        };
        this.removeTag = function (tag) {
            var index = _this.tags.indexOf(tag);
            _this.tags.splice(index, 1);
        };
        this.clear = function () {
            _this.tags = [];
        };
        this.reset = function () {
            _this.tags = tslib_1.__spreadArray([], tags, true);
        };
    }
    TagInputExample.prototype.view = function () {
        var _this = this;
        var isEmpty = this.tags.length === 0;
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.TagInput, {
                addOnBlur: this.addOnBlur,
                tags: this.tags.map(function (tag) { return (0, mithril_1.default)(_1.Tag, {
                    label: tag,
                    onRemove: function () { return _this.removeTag(tag); }
                }); }),
                disabled: this.disabled,
                intent: this.intent,
                size: this.size,
                contentLeft: (0, mithril_1.default)(_1.Icon, { name: _1.Icons.SETTINGS }),
                contentRight: (0, mithril_1.default)(_1.Icon, {
                    name: isEmpty ? _1.Icons.REFRESH_CW : _1.Icons.X,
                    onclick: isEmpty ? this.reset : this.clear
                }),
                onAdd: this.onAdd
            })
        ]);
    };
    TagInputExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Sizes'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } }),
            (0, mithril_1.default)('h5', 'Intent'),
            (0, mithril_1.default)(examples_1.IntentSelect, { onSelect: function (intent) { return _this.intent = intent; } }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.disabled,
                label: 'Disabled',
                onchange: function () { return _this.disabled = !_this.disabled; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.addOnBlur,
                label: 'Add on blur',
                onchange: function () { return _this.addOnBlur = !_this.addOnBlur; }
            })
        ];
    };
    return TagInputExample;
}());
exports.TagInputExample = TagInputExample;
